import { render } from "./CommonStatus.vue?vue&type=template&id=4fe48b05&ts=true"
import script from "./CommonStatus.vue?vue&type=script&lang=ts"
export * from "./CommonStatus.vue?vue&type=script&lang=ts"

import "./CommonStatus.vue?vue&type=style&index=0&id=4fe48b05&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__